import AmpersandCollection from 'ampersand-collection';
import StatusModel from './status-model';
import _ from 'lodash';

var StatusesCollection = AmpersandCollection.extend({
    model: StatusModel,

    resetAndMarkOldModelsAsDeleted(data, companyId) {
        const previousCollectionModels = _.clone(this.models)

        if (companyId) {
            this.resetByCompany(companyId, data)
        } else {
            this.reset(data, {parse:true})
        }

        // add models that are missing in new session Collection
        _.map(previousCollectionModels, model => {
            if (!this.get(model.id)) {
                model.isDeleted = true
                this.add(model)
            }
        })
    },

    resetByCompany: function(companyId,newData) {

        var old = this.filter(function(w){
            return w.companyId === companyId;
        });

        _.each(old,function(model){
            this.remove(model,{ silent: true });
        }.bind(this));

        this.add(newData,{parse:true});
    },

    findBySystemStatus: function(systemStatus) {
        return this.models.filter(function(s) {
            return (s.systemStatus===systemStatus);
        });
    },

    findByName(name) {
        name = name.toLowerCase();

        let found = false;

        this.map(option=>{
            if (option.name.toLowerCase()===name) found = option;
        });

        return found;
    },

    filterByCompany(companyId) {
        var filteredModels = this.filter(function(model){
            return (model.companyId===companyId);
        });
        return new StatusesCollection(filteredModels);
    },

    // Export all statuses in the company to options
    // used in automations at least
    toOptions() {
        // gd.session.statuses.filterByCompany(gd.companyId).models)
        const options = _.chain(this.models)
            .filter(m=>!m.isDeleted)
            .orderBy(['systemStatus','color',m=>m.name.toLowerCase()],['asc','asc','asc'])
            .map(m=>({
                value: m.id,
                color: m.color,
                label: m.name
            }))
            .value()

        return options
    },

    // exportToAutosuggest: function() {
    //     return this.map(function(m){
    //         return {
    //             name: m.name,
    //             color: m.color,
    //             id: m.id
    //         }
    //     })
    // }
});

module.exports = StatusesCollection;